import { useCallback, useRef } from 'react';

const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

function focusNextTabbable(fromEl) {
  const input = fromEl.querySelector?.('input') || fromEl;
  const nodes = Array.from(document.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
    (el) => el.offsetParent != null && !el.disabled && el.tabIndex !== -1
  );
  const idx = nodes.indexOf(input);
  if (idx >= 0 && idx < nodes.length - 1) {
    nodes[idx + 1].focus();
  }
}

/**
 * TAB com lista aberta confirma a opção destacada e move o foco (paridade select nativo / react-select).
 */
export function useAutocompleteTabSelect(applySelection) {
  const highlightedRef = useRef(null);

  const onHighlightChange = useCallback((_event, option) => {
    highlightedRef.current = option;
  }, []);

  const onKeyDown = useCallback(
    (event) => {
      if (event.key !== 'Tab' || event.shiftKey) return;
      if (typeof applySelection !== 'function') return;

      const highlighted = highlightedRef.current;
      if (highlighted == null) return;

      const expanded = event.currentTarget?.getAttribute?.('aria-expanded') === 'true';
      if (!expanded) return;

      event.preventDefault();
      applySelection(event, highlighted);
      requestAnimationFrame(() => focusNextTabbable(event.currentTarget));
    },
    [applySelection]
  );

  return { onHighlightChange, onKeyDown };
}
